
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire37b7"];
var parcelRegister = parcelRequire.register;
parcelRegister("8z7c3", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", function () { return $63c72c0e59d16915$export$3dbd3405086fec7b; });
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", function () { return $63c72c0e59d16915$export$cbabb21c2529b130; });
$parcel$export(module.exports, "Manager", function () { return $63c72c0e59d16915$export$d0d38e7dec7a1a61; });

var $91i6m = parcelRequire("91i6m");
var $63c72c0e59d16915$export$3dbd3405086fec7b = $91i6m.createContext();
var $63c72c0e59d16915$export$cbabb21c2529b130 = $91i6m.createContext();
function $63c72c0e59d16915$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $91i6m.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $91i6m.useRef(false);
    $91i6m.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $91i6m.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $91i6m.createElement($63c72c0e59d16915$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $91i6m.createElement($63c72c0e59d16915$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("blZ6m", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $84410d63031fa907$export$badac9ada3a0bdf9; });

var $91i6m = parcelRequire("91i6m");

var $8z7c3 = parcelRequire("8z7c3");

var $ippcL = parcelRequire("ippcL");

var $7GKpb = parcelRequire("7GKpb");
var $84410d63031fa907$var$NOOP = function NOOP() {
    return void 0;
};
var $84410d63031fa907$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $84410d63031fa907$var$EMPTY_MODIFIERS = [];
function $84410d63031fa907$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom" : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "absolute" : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $84410d63031fa907$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $91i6m.useContext((0, $8z7c3.ManagerReferenceNodeContext));
    var _React$useState = $91i6m.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $91i6m.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $91i6m.useEffect(function() {
        (0, $ippcL.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $91i6m.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: "arrow",
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $7GKpb.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $91i6m.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $84410d63031fa907$var$NOOP,
            update: update || $84410d63031fa907$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $ippcL.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("ippcL", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", function () { return $d66e1cf0dfd38041$export$f52c55943429c8b6; });
$parcel$export(module.exports, "safeInvoke", function () { return $d66e1cf0dfd38041$export$3dfa7c28635fe028; });
$parcel$export(module.exports, "setRef", function () { return $d66e1cf0dfd38041$export$4bb192c7cacf928f; });
$parcel$export(module.exports, "fromEntries", function () { return $d66e1cf0dfd38041$export$5150077fc2e7c662; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $d66e1cf0dfd38041$export$700979bc83e7db82; });

var $91i6m = parcelRequire("91i6m");
var $d66e1cf0dfd38041$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $d66e1cf0dfd38041$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $d66e1cf0dfd38041$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return $d66e1cf0dfd38041$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $d66e1cf0dfd38041$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $d66e1cf0dfd38041$export$700979bc83e7db82 = typeof window !== "undefined" && window.document && window.document.createElement ? $91i6m.useLayoutEffect : $91i6m.useEffect;

});

parcelRegister("7GKpb", function(module, exports) {

$parcel$export(module.exports, "usePopper", function () { return $0171d0518b33def6$export$f4d5bf230a36dd6e; });

var $91i6m = parcelRequire("91i6m");

var $eAqbf = parcelRequire("eAqbf");

var $cBZUw = parcelRequire("cBZUw");

var $lPtyF = parcelRequire("lPtyF");

var $ippcL = parcelRequire("ippcL");
var $0171d0518b33def6$var$EMPTY_MODIFIERS = [];
var $0171d0518b33def6$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $91i6m.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || $0171d0518b33def6$var$EMPTY_MODIFIERS
    };
    var _React$useState = $91i6m.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $91i6m.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $eAqbf.flushSync(function() {
                    setState({
                        styles: (0, $ippcL.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $ippcL.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = $91i6m.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($lPtyF)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $91i6m.useRef();
    (0, $ippcL.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $ippcL.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $cBZUw.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("cBZUw", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $92e8f6e3f4bf01da$export$8f7491d57c8f97a9; });

var $5V4V2 = parcelRequire("5V4V2");

var $dDwnX = parcelRequire("dDwnX");

var $5n2As = parcelRequire("5n2As");

var $15qRt = parcelRequire("15qRt");

var $2uPqK = parcelRequire("2uPqK");

var $3ksXK = parcelRequire("3ksXK");

var $8aUYP = parcelRequire("8aUYP");

var $OI30W = parcelRequire("OI30W");

var $fQ95C = parcelRequire("fQ95C");

var $amUyP = parcelRequire("amUyP");


var $92e8f6e3f4bf01da$export$d34966752335dd47 = [
    (0, $dDwnX.default),
    (0, $5n2As.default),
    (0, $15qRt.default),
    (0, $2uPqK.default),
    (0, $3ksXK.default),
    (0, $8aUYP.default),
    (0, $OI30W.default),
    (0, $fQ95C.default),
    (0, $amUyP.default)
];
var $92e8f6e3f4bf01da$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $5V4V2.popperGenerator)({
    defaultModifiers: $92e8f6e3f4bf01da$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("5V4V2", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $44f61767b651c4e6$export$ed5e13716264f202; });

var $akwxK = parcelRequire("akwxK");

var $hLC6U = parcelRequire("hLC6U");

var $4Hb4t = parcelRequire("4Hb4t");

var $4CII3 = parcelRequire("4CII3");

var $HBGDV = parcelRequire("HBGDV");

var $bxx1T = parcelRequire("bxx1T");

var $dRERv = parcelRequire("dRERv");


var $7HECO = parcelRequire("7HECO");
var $44f61767b651c4e6$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $44f61767b651c4e6$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $44f61767b651c4e6$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $44f61767b651c4e6$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $44f61767b651c4e6$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $7HECO.isElement)(reference) ? (0, $4Hb4t.default)(reference) : reference.contextElement ? (0, $4Hb4t.default)(reference.contextElement) : [],
                    popper: (0, $4Hb4t.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $HBGDV.default)((0, $dRERv.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$44f61767b651c4e6$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $akwxK.default)(reference, (0, $4CII3.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, $hLC6U.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $bxx1T.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$44f61767b651c4e6$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $44f61767b651c4e6$export$8f7491d57c8f97a9 = /*#__PURE__*/ $44f61767b651c4e6$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("akwxK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $785504161e249728$export$2e2bcd8739ae039; });

var $l33kQ = parcelRequire("l33kQ");

var $8w72e = parcelRequire("8w72e");

var $fdq7r = parcelRequire("fdq7r");

var $7HECO = parcelRequire("7HECO");

var $ioUza = parcelRequire("ioUza");

var $74CGk = parcelRequire("74CGk");

var $kg8mx = parcelRequire("kg8mx");

var $6SHZD = parcelRequire("6SHZD");
function $785504161e249728$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $6SHZD.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $6SHZD.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $785504161e249728$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $7HECO.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $7HECO.isHTMLElement)(offsetParent) && $785504161e249728$var$isElementScaled(offsetParent);
    var documentElement = (0, $74CGk.default)(offsetParent);
    var rect = (0, $l33kQ.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $fdq7r.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $kg8mx.default)(documentElement)) scroll = (0, $8w72e.default)(offsetParent);
        if ((0, $7HECO.isHTMLElement)(offsetParent)) {
            offsets = (0, $l33kQ.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $ioUza.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("l33kQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f52c77119e6a9356$export$2e2bcd8739ae039; });

var $7HECO = parcelRequire("7HECO");

var $6SHZD = parcelRequire("6SHZD");

var $8svyU = parcelRequire("8svyU");

var $anT1G = parcelRequire("anT1G");
function $f52c77119e6a9356$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $7HECO.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $6SHZD.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $6SHZD.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $7HECO.isElement)(element) ? (0, $8svyU.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $anT1G.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("7HECO", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $59bc0fd0277bf293$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $59bc0fd0277bf293$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $59bc0fd0277bf293$export$af51f0f06c0f328a; });

var $8svyU = parcelRequire("8svyU");
function $59bc0fd0277bf293$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $8svyU.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $59bc0fd0277bf293$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $8svyU.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $59bc0fd0277bf293$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $8svyU.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("8svyU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62896bd4626b8c61$export$2e2bcd8739ae039; });
function $62896bd4626b8c61$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("6SHZD", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $5029e959c9e6e756$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $5029e959c9e6e756$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $5029e959c9e6e756$export$2077e0241d6afd3c; });
var $5029e959c9e6e756$export$8960430cfd85939f = Math.max;
var $5029e959c9e6e756$export$96ec731ed4dcb222 = Math.min;
var $5029e959c9e6e756$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("anT1G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78f6bc69cbbbe065$export$2e2bcd8739ae039; });

var $6XuQN = parcelRequire("6XuQN");
function $78f6bc69cbbbe065$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6XuQN.default)());
}

});
parcelRegister("6XuQN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51102f10faa78409$export$2e2bcd8739ae039; });
function $51102f10faa78409$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

});



parcelRegister("8w72e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6336c4e7b4c6d67f$export$2e2bcd8739ae039; });

var $dI4Q8 = parcelRequire("dI4Q8");

var $8svyU = parcelRequire("8svyU");

var $7HECO = parcelRequire("7HECO");

var $cAHL0 = parcelRequire("cAHL0");
function $6336c4e7b4c6d67f$export$2e2bcd8739ae039(node) {
    if (node === (0, $8svyU.default)(node) || !(0, $7HECO.isHTMLElement)(node)) return (0, $dI4Q8.default)(node);
    else return (0, $cAHL0.default)(node);
}

});
parcelRegister("dI4Q8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fb32385ab603c08$export$2e2bcd8739ae039; });

var $8svyU = parcelRequire("8svyU");
function $9fb32385ab603c08$export$2e2bcd8739ae039(node) {
    var win = (0, $8svyU.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("cAHL0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92aaca154a013233$export$2e2bcd8739ae039; });
function $92aaca154a013233$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("fdq7r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b13c5497956e9804$export$2e2bcd8739ae039; });
function $b13c5497956e9804$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRegister("ioUza", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d65658c5aff358f9$export$2e2bcd8739ae039; });

var $l33kQ = parcelRequire("l33kQ");

var $74CGk = parcelRequire("74CGk");

var $dI4Q8 = parcelRequire("dI4Q8");
function $d65658c5aff358f9$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $l33kQ.default)((0, $74CGk.default)(element)).left + (0, $dI4Q8.default)(element).scrollLeft;
}

});
parcelRegister("74CGk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5266e98202e3819b$export$2e2bcd8739ae039; });

var $7HECO = parcelRequire("7HECO");
function $5266e98202e3819b$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $7HECO.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("kg8mx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebfbc9ea4fa75b43$export$2e2bcd8739ae039; });

var $6NmcB = parcelRequire("6NmcB");
function $ebfbc9ea4fa75b43$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $6NmcB.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("6NmcB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f288a91dde2f0d8$export$2e2bcd8739ae039; });

var $8svyU = parcelRequire("8svyU");
function $4f288a91dde2f0d8$export$2e2bcd8739ae039(element) {
    return (0, $8svyU.default)(element).getComputedStyle(element);
}

});



parcelRegister("hLC6U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cef46362711233ac$export$2e2bcd8739ae039; });

var $l33kQ = parcelRequire("l33kQ");
function $cef46362711233ac$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $l33kQ.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("4Hb4t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36b3c41180e8acea$export$2e2bcd8739ae039; });

var $5NxuV = parcelRequire("5NxuV");

var $6gvS8 = parcelRequire("6gvS8");

var $8svyU = parcelRequire("8svyU");

var $kg8mx = parcelRequire("kg8mx");
function $36b3c41180e8acea$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $5NxuV.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $8svyU.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $kg8mx.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($36b3c41180e8acea$export$2e2bcd8739ae039((0, $6gvS8.default)(target)));
}

});
parcelRegister("5NxuV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $438b834c99d4315d$export$2e2bcd8739ae039; });

var $6gvS8 = parcelRequire("6gvS8");

var $kg8mx = parcelRequire("kg8mx");

var $fdq7r = parcelRequire("fdq7r");

var $7HECO = parcelRequire("7HECO");
function $438b834c99d4315d$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $fdq7r.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $7HECO.isHTMLElement)(node) && (0, $kg8mx.default)(node)) return node;
    return $438b834c99d4315d$export$2e2bcd8739ae039((0, $6gvS8.default)(node));
}

});
parcelRegister("6gvS8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48fcf5da9ac9506c$export$2e2bcd8739ae039; });

var $fdq7r = parcelRequire("fdq7r");

var $74CGk = parcelRequire("74CGk");

var $7HECO = parcelRequire("7HECO");
function $48fcf5da9ac9506c$export$2e2bcd8739ae039(element) {
    if ((0, $fdq7r.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $7HECO.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $74CGk.default)(element) // fallback
    );
}

});



parcelRegister("4CII3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35dd6468dcfc5859$export$2e2bcd8739ae039; });

var $8svyU = parcelRequire("8svyU");

var $fdq7r = parcelRequire("fdq7r");

var $6NmcB = parcelRequire("6NmcB");

var $7HECO = parcelRequire("7HECO");

var $hvXls = parcelRequire("hvXls");

var $6gvS8 = parcelRequire("6gvS8");

var $6XuQN = parcelRequire("6XuQN");
function $35dd6468dcfc5859$var$getTrueOffsetParent(element) {
    if (!(0, $7HECO.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $6NmcB.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $35dd6468dcfc5859$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6XuQN.default)());
    var isIE = /Trident/i.test((0, $6XuQN.default)());
    if (isIE && (0, $7HECO.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $6NmcB.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $6gvS8.default)(element);
    if ((0, $7HECO.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $7HECO.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $fdq7r.default)(currentNode)) < 0){
        var css = (0, $6NmcB.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $35dd6468dcfc5859$export$2e2bcd8739ae039(element) {
    var window = (0, $8svyU.default)(element);
    var offsetParent = $35dd6468dcfc5859$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $hvXls.default)(offsetParent) && (0, $6NmcB.default)(offsetParent).position === "static")offsetParent = $35dd6468dcfc5859$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $fdq7r.default)(offsetParent) === "html" || (0, $fdq7r.default)(offsetParent) === "body" && (0, $6NmcB.default)(offsetParent).position === "static")) return window;
    return offsetParent || $35dd6468dcfc5859$var$getContainingBlock(element) || window;
}

});
parcelRegister("hvXls", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc035d9c78014b1f$export$2e2bcd8739ae039; });

var $fdq7r = parcelRequire("fdq7r");
function $cc035d9c78014b1f$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $fdq7r.default)(element)) >= 0;
}

});


parcelRegister("HBGDV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0831401406a78d78$export$2e2bcd8739ae039; });

var $hrOxP = parcelRequire("hrOxP");
function $0831401406a78d78$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $0831401406a78d78$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $0831401406a78d78$var$order(modifiers); // order based on phase
    return (0, $hrOxP.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("hrOxP", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $cb3c2a64de595288$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $cb3c2a64de595288$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $cb3c2a64de595288$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $cb3c2a64de595288$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $cb3c2a64de595288$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $cb3c2a64de595288$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $cb3c2a64de595288$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $cb3c2a64de595288$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $cb3c2a64de595288$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $cb3c2a64de595288$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $cb3c2a64de595288$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $cb3c2a64de595288$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $cb3c2a64de595288$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $cb3c2a64de595288$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $cb3c2a64de595288$export$d087d3878fdf71d5; });
var $cb3c2a64de595288$export$1e95b668f3b82d = "top";
var $cb3c2a64de595288$export$40e543e69a8b3fbb = "bottom";
var $cb3c2a64de595288$export$79ffe56a765070d2 = "right";
var $cb3c2a64de595288$export$eabcd2c8791e7bf4 = "left";
var $cb3c2a64de595288$export$dfb5619354ba860 = "auto";
var $cb3c2a64de595288$export$aec2ce47c367b8c3 = [
    $cb3c2a64de595288$export$1e95b668f3b82d,
    $cb3c2a64de595288$export$40e543e69a8b3fbb,
    $cb3c2a64de595288$export$79ffe56a765070d2,
    $cb3c2a64de595288$export$eabcd2c8791e7bf4
];
var $cb3c2a64de595288$export$b3571188c770cc5a = "start";
var $cb3c2a64de595288$export$bd5df0f255a350f8 = "end";
var $cb3c2a64de595288$export$390fd549c5303b4d = "clippingParents";
var $cb3c2a64de595288$export$d7b7311ec04a3e8f = "viewport";
var $cb3c2a64de595288$export$ae5ab1c730825774 = "popper";
var $cb3c2a64de595288$export$ca50aac9f3ba507f = "reference";
var $cb3c2a64de595288$export$368f9a87e87fa4e1 = /*#__PURE__*/ $cb3c2a64de595288$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $cb3c2a64de595288$export$b3571188c770cc5a,
        placement + "-" + $cb3c2a64de595288$export$bd5df0f255a350f8
    ]);
}, []);
var $cb3c2a64de595288$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($cb3c2a64de595288$export$aec2ce47c367b8c3, [
    $cb3c2a64de595288$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $cb3c2a64de595288$export$b3571188c770cc5a,
        placement + "-" + $cb3c2a64de595288$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $cb3c2a64de595288$export$421679a7c3d56e = "beforeRead";
var $cb3c2a64de595288$export$aafa59e2e03f2942 = "read";
var $cb3c2a64de595288$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $cb3c2a64de595288$export$c65e99957a05207c = "beforeMain";
var $cb3c2a64de595288$export$f22da7240b7add18 = "main";
var $cb3c2a64de595288$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $cb3c2a64de595288$export$8d4d2d70e7d46032 = "beforeWrite";
var $cb3c2a64de595288$export$68d8715fc104d294 = "write";
var $cb3c2a64de595288$export$70a6e5159acce2e6 = "afterWrite";
var $cb3c2a64de595288$export$d087d3878fdf71d5 = [
    $cb3c2a64de595288$export$421679a7c3d56e,
    $cb3c2a64de595288$export$aafa59e2e03f2942,
    $cb3c2a64de595288$export$6964f6c886723980,
    $cb3c2a64de595288$export$c65e99957a05207c,
    $cb3c2a64de595288$export$f22da7240b7add18,
    $cb3c2a64de595288$export$bab79516f2d662fe,
    $cb3c2a64de595288$export$8d4d2d70e7d46032,
    $cb3c2a64de595288$export$68d8715fc104d294,
    $cb3c2a64de595288$export$70a6e5159acce2e6
];

});


parcelRegister("bxx1T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $866c65c2cba6c37c$export$2e2bcd8739ae039; });
function $866c65c2cba6c37c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("dRERv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a17febecdf8a8bb6$export$2e2bcd8739ae039; });
function $a17febecdf8a8bb6$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("dDwnX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ed809edcd44cd97$export$2e2bcd8739ae039; });

var $8svyU = parcelRequire("8svyU");
var $9ed809edcd44cd97$var$passive = {
    passive: true
};
function $9ed809edcd44cd97$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $8svyU.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $9ed809edcd44cd97$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $9ed809edcd44cd97$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $9ed809edcd44cd97$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $9ed809edcd44cd97$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $9ed809edcd44cd97$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $9ed809edcd44cd97$var$effect,
    data: {}
};

});

parcelRegister("5n2As", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e911b749cea99a5$export$2e2bcd8739ae039; });

var $aJQMB = parcelRequire("aJQMB");
function $3e911b749cea99a5$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $aJQMB.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $3e911b749cea99a5$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $3e911b749cea99a5$var$popperOffsets,
    data: {}
};

});
parcelRegister("aJQMB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d170cf714e82392$export$2e2bcd8739ae039; });

var $1lqsE = parcelRequire("1lqsE");

var $iFCgR = parcelRequire("iFCgR");

var $1rznO = parcelRequire("1rznO");

var $hrOxP = parcelRequire("hrOxP");
function $7d170cf714e82392$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $1lqsE.default)(placement) : null;
    var variation = placement ? (0, $iFCgR.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $hrOxP.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $hrOxP.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $hrOxP.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $hrOxP.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $1rznO.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $hrOxP.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $hrOxP.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("1lqsE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fac473aa49342b9$export$2e2bcd8739ae039; });

function $0fac473aa49342b9$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRegister("iFCgR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d979be1f69b8abe9$export$2e2bcd8739ae039; });
function $d979be1f69b8abe9$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});

parcelRegister("1rznO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10d3c26102a2c0dd$export$2e2bcd8739ae039; });
function $10d3c26102a2c0dd$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});



parcelRegister("15qRt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cab1836682443b2$export$2e2bcd8739ae039; });

var $hrOxP = parcelRequire("hrOxP");

var $4CII3 = parcelRequire("4CII3");

var $8svyU = parcelRequire("8svyU");

var $74CGk = parcelRequire("74CGk");

var $6NmcB = parcelRequire("6NmcB");

var $1lqsE = parcelRequire("1lqsE");

var $iFCgR = parcelRequire("iFCgR");

var $6SHZD = parcelRequire("6SHZD");
var $0cab1836682443b2$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $0cab1836682443b2$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $6SHZD.round)(x * dpr) / dpr || 0,
        y: (0, $6SHZD.round)(y * dpr) / dpr || 0
    };
}
function $0cab1836682443b2$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $hrOxP.left);
    var sideY = (0, $hrOxP.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $4CII3.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $8svyU.default)(popper)) {
            offsetParent = (0, $74CGk.default)(popper);
            if ((0, $6NmcB.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $hrOxP.top) || (placement === (0, $hrOxP.left) || placement === (0, $hrOxP.right)) && variation === (0, $hrOxP.end)) {
            sideY = (0, $hrOxP.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $hrOxP.left) || (placement === (0, $hrOxP.top) || placement === (0, $hrOxP.bottom)) && variation === (0, $hrOxP.end)) {
            sideX = (0, $hrOxP.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $0cab1836682443b2$var$unsetSides);
    var _ref4 = roundOffsets === true ? $0cab1836682443b2$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $8svyU.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $0cab1836682443b2$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $1lqsE.default)(state.placement),
        variation: (0, $iFCgR.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $0cab1836682443b2$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $0cab1836682443b2$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $0cab1836682443b2$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $0cab1836682443b2$var$computeStyles,
    data: {}
};

});

parcelRegister("2uPqK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d164720c72a7c28$export$2e2bcd8739ae039; });

var $fdq7r = parcelRequire("fdq7r");

var $7HECO = parcelRequire("7HECO");
// and applies them to the HTMLElements such as popper and arrow
function $1d164720c72a7c28$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $7HECO.isHTMLElement)(element) || !(0, $fdq7r.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $1d164720c72a7c28$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $7HECO.isHTMLElement)(element) || !(0, $fdq7r.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $1d164720c72a7c28$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $1d164720c72a7c28$var$applyStyles,
    effect: $1d164720c72a7c28$var$effect,
    requires: [
        "computeStyles"
    ]
};

});

parcelRegister("3ksXK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26c9b4bc8c7e1d81$export$2e2bcd8739ae039; });

var $1lqsE = parcelRequire("1lqsE");

var $hrOxP = parcelRequire("hrOxP");
function $26c9b4bc8c7e1d81$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $1lqsE.default)(placement);
    var invertDistance = [
        (0, $hrOxP.left),
        (0, $hrOxP.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $hrOxP.left),
        (0, $hrOxP.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $26c9b4bc8c7e1d81$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $hrOxP.placements).reduce(function(acc, placement) {
        acc[placement] = $26c9b4bc8c7e1d81$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $26c9b4bc8c7e1d81$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $26c9b4bc8c7e1d81$var$offset
};

});

parcelRegister("8aUYP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f3b74f8e33912c9$export$2e2bcd8739ae039; });

var $8ukq2 = parcelRequire("8ukq2");

var $1lqsE = parcelRequire("1lqsE");

var $ajkwZ = parcelRequire("ajkwZ");

var $7rvV0 = parcelRequire("7rvV0");

var $bw3iH = parcelRequire("bw3iH");

var $hrOxP = parcelRequire("hrOxP");

var $iFCgR = parcelRequire("iFCgR");
function $5f3b74f8e33912c9$var$getExpandedFallbackPlacements(placement) {
    if ((0, $1lqsE.default)(placement) === (0, $hrOxP.auto)) return [];
    var oppositePlacement = (0, $8ukq2.default)(placement);
    return [
        (0, $ajkwZ.default)(placement),
        oppositePlacement,
        (0, $ajkwZ.default)(oppositePlacement)
    ];
}
function $5f3b74f8e33912c9$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $1lqsE.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $8ukq2.default)(preferredPlacement)
    ] : $5f3b74f8e33912c9$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $1lqsE.default)(placement) === (0, $hrOxP.auto) ? (0, $bw3iH.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $1lqsE.default)(placement);
        var isStartVariation = (0, $iFCgR.default)(placement) === (0, $hrOxP.start);
        var isVertical = [
            (0, $hrOxP.top),
            (0, $hrOxP.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $7rvV0.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $hrOxP.right) : (0, $hrOxP.left) : isStartVariation ? (0, $hrOxP.bottom) : (0, $hrOxP.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $8ukq2.default)(mainVariationSide);
        var altVariationSide = (0, $8ukq2.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $5f3b74f8e33912c9$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $5f3b74f8e33912c9$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("8ukq2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62e0f6df47359661$export$2e2bcd8739ae039; });
var $62e0f6df47359661$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $62e0f6df47359661$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $62e0f6df47359661$var$hash[matched];
    });
}

});

parcelRegister("ajkwZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $781b9acb38eb0c2f$export$2e2bcd8739ae039; });
var $781b9acb38eb0c2f$var$hash = {
    start: "end",
    end: "start"
};
function $781b9acb38eb0c2f$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $781b9acb38eb0c2f$var$hash[matched];
    });
}

});

parcelRegister("7rvV0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56b3d056755e4172$export$2e2bcd8739ae039; });

var $ll4J0 = parcelRequire("ll4J0");

var $74CGk = parcelRequire("74CGk");

var $l33kQ = parcelRequire("l33kQ");

var $aJQMB = parcelRequire("aJQMB");

var $jhSNt = parcelRequire("jhSNt");

var $hrOxP = parcelRequire("hrOxP");

var $7HECO = parcelRequire("7HECO");

var $arCOq = parcelRequire("arCOq");

var $iKqvW = parcelRequire("iKqvW");
function $56b3d056755e4172$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $hrOxP.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $hrOxP.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $hrOxP.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $arCOq.default)(typeof padding !== "number" ? padding : (0, $iKqvW.default)(padding, (0, $hrOxP.basePlacements)));
    var altContext = elementContext === (0, $hrOxP.popper) ? (0, $hrOxP.reference) : (0, $hrOxP.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $ll4J0.default)((0, $7HECO.isElement)(element) ? element : element.contextElement || (0, $74CGk.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $l33kQ.default)(state.elements.reference);
    var popperOffsets = (0, $aJQMB.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $jhSNt.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $hrOxP.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $hrOxP.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $hrOxP.right),
                (0, $hrOxP.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $hrOxP.top),
                (0, $hrOxP.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("ll4J0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f88f396dad276b09$export$2e2bcd8739ae039; });

var $hrOxP = parcelRequire("hrOxP");

var $iMoRm = parcelRequire("iMoRm");

var $ggoOw = parcelRequire("ggoOw");

var $4Hb4t = parcelRequire("4Hb4t");

var $4CII3 = parcelRequire("4CII3");

var $74CGk = parcelRequire("74CGk");

var $6NmcB = parcelRequire("6NmcB");

var $7HECO = parcelRequire("7HECO");

var $l33kQ = parcelRequire("l33kQ");

var $6gvS8 = parcelRequire("6gvS8");

var $emjeY = parcelRequire("emjeY");

var $fdq7r = parcelRequire("fdq7r");

var $jhSNt = parcelRequire("jhSNt");

var $6SHZD = parcelRequire("6SHZD");
function $f88f396dad276b09$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $l33kQ.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $f88f396dad276b09$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $hrOxP.viewport) ? (0, $jhSNt.default)((0, $iMoRm.default)(element, strategy)) : (0, $7HECO.isElement)(clippingParent) ? $f88f396dad276b09$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $jhSNt.default)((0, $ggoOw.default)((0, $74CGk.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $f88f396dad276b09$var$getClippingParents(element) {
    var clippingParents = (0, $4Hb4t.default)((0, $6gvS8.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $6NmcB.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $7HECO.isHTMLElement)(element) ? (0, $4CII3.default)(element) : element;
    if (!(0, $7HECO.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $7HECO.isElement)(clippingParent) && (0, $emjeY.default)(clippingParent, clipperElement) && (0, $fdq7r.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $f88f396dad276b09$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $f88f396dad276b09$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $f88f396dad276b09$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $6SHZD.max)(rect.top, accRect.top);
        accRect.right = (0, $6SHZD.min)(rect.right, accRect.right);
        accRect.bottom = (0, $6SHZD.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $6SHZD.max)(rect.left, accRect.left);
        return accRect;
    }, $f88f396dad276b09$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("iMoRm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dabffe4d04742317$export$2e2bcd8739ae039; });

var $8svyU = parcelRequire("8svyU");

var $74CGk = parcelRequire("74CGk");

var $ioUza = parcelRequire("ioUza");

var $anT1G = parcelRequire("anT1G");
function $dabffe4d04742317$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $8svyU.default)(element);
    var html = (0, $74CGk.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $anT1G.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $ioUza.default)(element),
        y: y
    };
}

});

parcelRegister("ggoOw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd716381ee60c49f$export$2e2bcd8739ae039; });

var $74CGk = parcelRequire("74CGk");

var $6NmcB = parcelRequire("6NmcB");

var $ioUza = parcelRequire("ioUza");

var $dI4Q8 = parcelRequire("dI4Q8");

var $6SHZD = parcelRequire("6SHZD");
function $bd716381ee60c49f$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $74CGk.default)(element);
    var winScroll = (0, $dI4Q8.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $6SHZD.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $6SHZD.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $ioUza.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $6NmcB.default)(body || html).direction === "rtl") x += (0, $6SHZD.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("emjeY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7420b8c23844178$export$2e2bcd8739ae039; });

var $7HECO = parcelRequire("7HECO");
function $a7420b8c23844178$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $7HECO.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("jhSNt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0aa1c5df4a188e9$export$2e2bcd8739ae039; });
function $e0aa1c5df4a188e9$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("arCOq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79aa884f7348a8ca$export$2e2bcd8739ae039; });

var $gaqC8 = parcelRequire("gaqC8");
function $79aa884f7348a8ca$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $gaqC8.default)(), paddingObject);
}

});
parcelRegister("gaqC8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc523987432af8fa$export$2e2bcd8739ae039; });
function $bc523987432af8fa$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("iKqvW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da611709504de0e2$export$2e2bcd8739ae039; });
function $da611709504de0e2$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("bw3iH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86253e484dd04be1$export$2e2bcd8739ae039; });

var $iFCgR = parcelRequire("iFCgR");

var $hrOxP = parcelRequire("hrOxP");

var $7rvV0 = parcelRequire("7rvV0");

var $1lqsE = parcelRequire("1lqsE");
function $86253e484dd04be1$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $hrOxP.placements) : _options$allowedAutoP;
    var variation = (0, $iFCgR.default)(placement);
    var placements = variation ? flipVariations ? (0, $hrOxP.variationPlacements) : (0, $hrOxP.variationPlacements).filter(function(placement) {
        return (0, $iFCgR.default)(placement) === variation;
    }) : (0, $hrOxP.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $7rvV0.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $1lqsE.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("OI30W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0986d690bad5923d$export$2e2bcd8739ae039; });

var $hrOxP = parcelRequire("hrOxP");

var $1lqsE = parcelRequire("1lqsE");

var $1rznO = parcelRequire("1rznO");

var $bb4wq = parcelRequire("bb4wq");

var $2I0ZK = parcelRequire("2I0ZK");

var $hLC6U = parcelRequire("hLC6U");

var $4CII3 = parcelRequire("4CII3");

var $7rvV0 = parcelRequire("7rvV0");

var $iFCgR = parcelRequire("iFCgR");

var $gaqC8 = parcelRequire("gaqC8");

var $6SHZD = parcelRequire("6SHZD");
function $0986d690bad5923d$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $7rvV0.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $1lqsE.default)(state.placement);
    var variation = (0, $iFCgR.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $1rznO.default)(basePlacement);
    var altAxis = (0, $bb4wq.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $hrOxP.top) : (0, $hrOxP.left);
        var altSide = mainAxis === "y" ? (0, $hrOxP.bottom) : (0, $hrOxP.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $hrOxP.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $hrOxP.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $hLC6U.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $gaqC8.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $2I0ZK.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $4CII3.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $2I0ZK.within)(tether ? (0, $6SHZD.min)(min, tetherMin) : min, offset, tether ? (0, $6SHZD.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $hrOxP.top) : (0, $hrOxP.left);
        var _altSide = mainAxis === "x" ? (0, $hrOxP.bottom) : (0, $hrOxP.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $hrOxP.top),
            (0, $hrOxP.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $2I0ZK.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $2I0ZK.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $0986d690bad5923d$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $0986d690bad5923d$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRegister("bb4wq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82343ac14d834b52$export$2e2bcd8739ae039; });
function $82343ac14d834b52$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});

parcelRegister("2I0ZK", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $1f90766b5072cdd9$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $1f90766b5072cdd9$export$86c8af6d3ef0b4a; });

var $6SHZD = parcelRequire("6SHZD");
function $1f90766b5072cdd9$export$f28d906d67a997f3(min, value, max) {
    return (0, $6SHZD.max)(min, (0, $6SHZD.min)(value, max));
}
function $1f90766b5072cdd9$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $1f90766b5072cdd9$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("fQ95C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b882c35cdd9ffb51$export$2e2bcd8739ae039; });

var $1lqsE = parcelRequire("1lqsE");

var $hLC6U = parcelRequire("hLC6U");

var $emjeY = parcelRequire("emjeY");

var $4CII3 = parcelRequire("4CII3");

var $1rznO = parcelRequire("1rznO");

var $2I0ZK = parcelRequire("2I0ZK");

var $arCOq = parcelRequire("arCOq");

var $iKqvW = parcelRequire("iKqvW");

var $hrOxP = parcelRequire("hrOxP");
var $b882c35cdd9ffb51$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $arCOq.default)(typeof padding !== "number" ? padding : (0, $iKqvW.default)(padding, (0, $hrOxP.basePlacements)));
};
function $b882c35cdd9ffb51$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $1lqsE.default)(state.placement);
    var axis = (0, $1rznO.default)(basePlacement);
    var isVertical = [
        (0, $hrOxP.left),
        (0, $hrOxP.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $b882c35cdd9ffb51$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $hLC6U.default)(arrowElement);
    var minProp = axis === "y" ? (0, $hrOxP.top) : (0, $hrOxP.left);
    var maxProp = axis === "y" ? (0, $hrOxP.bottom) : (0, $hrOxP.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $4CII3.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $2I0ZK.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $b882c35cdd9ffb51$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $emjeY.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $b882c35cdd9ffb51$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $b882c35cdd9ffb51$var$arrow,
    effect: $b882c35cdd9ffb51$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});

parcelRegister("amUyP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78c7d53ca7a035cf$export$2e2bcd8739ae039; });

var $hrOxP = parcelRequire("hrOxP");

var $7rvV0 = parcelRequire("7rvV0");
function $78c7d53ca7a035cf$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $78c7d53ca7a035cf$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $hrOxP.top),
        (0, $hrOxP.right),
        (0, $hrOxP.bottom),
        (0, $hrOxP.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $78c7d53ca7a035cf$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $7rvV0.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $7rvV0.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $78c7d53ca7a035cf$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $78c7d53ca7a035cf$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $78c7d53ca7a035cf$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $78c7d53ca7a035cf$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $78c7d53ca7a035cf$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $78c7d53ca7a035cf$var$hide
};

});


parcelRegister("lPtyF", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $fe454a05b85ce062$var$hasElementType = typeof Element !== "undefined";
var $fe454a05b85ce062$var$hasMap = typeof Map === "function";
var $fe454a05b85ce062$var$hasSet = typeof Set === "function";
var $fe454a05b85ce062$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $fe454a05b85ce062$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$fe454a05b85ce062$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($fe454a05b85ce062$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$fe454a05b85ce062$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($fe454a05b85ce062$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($fe454a05b85ce062$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($fe454a05b85ce062$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$fe454a05b85ce062$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $fe454a05b85ce062$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});




//# sourceMappingURL=MultiFactorPage.cf54b9b3.js.map
